import type { SystemNotificationV1 } from '@/shared/api';

/**
 * Получает ID уведомления из API
 */
export const getAlertId = (alert: SystemNotificationV1) => {
	return alert.id;
};
